import { CoreApi } from '/src/helpers/CoreApi'
import Layout from '/src/components/@common.blocks/Layout'
import PrefaceCollection from '/src/components/@sections/PrefaceCollection'
import CollectionAssets from '/src/components/@sections/CollectionAssets'

const CollectionPage = ({ collection }) => {
  return (
    <Layout
      title={`${collection.name} NFT Rarity Ranking`}
      description={collection.description}
      footer={false}
      headerTheme='ghost'
      previewImage={collection.previewImage}
      className='page-collection'
    >
      <PrefaceCollection data={collection} />
      <CollectionAssets collection={collection} />
    </Layout>
  )
}

export async function getServerSideProps(ctx) {
  const { slug } = ctx.query
  const [collection] = await Promise.all([CoreApi.getCollectionBySlug(slug)])
  return {
    props: { collection },
  }
}

export default CollectionPage
